import { Link } from 'react-router-dom';
import { FiltersSlide } from 'ypf-pas-general-ui-components';
import { BsChevronLeft } from 'react-icons/bs';
import PropTypes from 'prop-types';
import { useMemo } from 'react';

import { apiCertificationsApp } from '../../../../resources/environmentConstants';
import { getUrlWithSessionCreds } from '../../../../utils/globalFunctions';
import baseStyles from '../../styles/base.module.scss';

import styles from './Header.module.scss';

/**
 * @typedef Props
 * @property {(newSortType: import('../../hooks/useSort').SortType) => void} changeSortType
 * @property {boolean} isInspector
 * @property {boolean} isLoading
 * @property {() => void} reloadTable
 * @property {SortType} sortType
 */

/** @param {Props} */
const Header = ({ isInspector, isLoading, handleChips, handleDeleteChips }) => {
  const mapFilters = useMemo(() => {
    if (handleChips) {
      return handleChips();
    }

    return [];
  }, [handleChips]);

  const deleteFilter = (filterObj) => {
    handleDeleteChips(filterObj);
  };

  return (
    <div className={styles['header-container']}>
      {isInspector ? (
        <a
          className={`${baseStyles['focus-ring']} ${styles.link} ${
            isLoading ? styles['no-events'] : ''
          }`}
          href={getUrlWithSessionCreds(`${apiCertificationsApp}/#/inspeccion/partes`)}
        >
          <BsChevronLeft /> Vista extendida
        </a>
      ) : (
        <Link
          className={`${baseStyles['focus-ring']} ${styles.link} ${
            isLoading ? styles['no-events'] : ''
          }`}
          to="/approver"
        >
          <BsChevronLeft /> Vista extendida
        </Link>
      )}

      <FiltersSlide
        arrayFilters={mapFilters}
        className={styles['filter-slide']}
        onDelete={(filterObj) => deleteFilter(filterObj)}
      />
    </div>
  );
};

export default Header;

Header.propTypes = {
  isInspector: PropTypes.bool.isRequired,
  isLoading: PropTypes.bool,
  handleChips: PropTypes.func.isRequired,
  handleDeleteChips: PropTypes.func.isRequired
};

Header.defaultProps = {
  isLoading: false
};
